import type { ReactNode } from 'react'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { AccessDenied } from 'shared/errors/access-denied'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import { PostAnnounceSkeleton } from 'modules/community/components/post-announce/components/post-announce-skeleton'
import PostDetails from 'modules/community/components/post/post-details'
import { usePost } from 'modules/community/post/hooks/use-post'

function Post(): ReactNode {
  const router = useRouter()
  const { communityPath, topicPath, postPath } = router.query

  const { data: post, error } = usePost({
    communityPath: communityPath,
    topicPath: topicPath,
    postPath: postPath as string,
  })

  useEffect(() => {
    if (error && error instanceof AccessDenied) {
      router.push(`/community/${communityPath}`)
    }
  }, [error, communityPath, router])

  if (!post) {
    return <PostAnnounceSkeleton />
  }

  return <PostDetails post={post} />
}

export const getServerSideProps = withDomainAssets(baseServerSideProps)

export default Post
